<template>
  <v-dialog v-model="dialog" max-width="1180px">
    <v-card>
      <v-card-title class="mx-3">
        <span
          class="red--text d-inline-block text-truncate"
          style="max-width: 640px"
        >
          {{ foodFormula.formula_code + "/" + foodFormula.formula_name }}
        </span>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false"
              >fa-times
            </v-icon>
          </template>
          <span>
            {{ $t("$vuetify.close") }}
          </span>
        </v-tooltip>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="costCardInfoItems"
        :loading="loading"
        multi-sort
        class="elevation-0 px-6"
        hide-default-footer
        :footer-props="$t('$config.footer-props')"
      >
        <template v-slot:item.material.Description="{ item }">
          <span>
            {{
              $t(settings
                  ? settings.material_name_display_type == 1
                      ? "Material.materialName"
                      : settings.material_name_display_type == 4
                          ? "Material.nameWithCode"
                      : "Material.materialNameWithCode"
                  : "Material.materialName", [item.material.material_code, item.material.material_name])
            }}
          </span>
        </template>
        <template v-slot:item.material.standard_name="{ item }">
          <span v-if="item.material.standard_name && item.material.standard_name.length > 12" :title="item.material.standard_name" style="cursor: pointer">
            {{ item.material.standard_name.slice(0, 12) + "......" }}
          </span>
          <span v-else>
            {{ item.material.standard_name }}
          </span>
        </template>
        <template v-slot:item.conversion_rate="{ item }">
          {{ item.conversion_rate }}
          {{ $t("Global.rate") }}
        </template>
        <template v-slot:item.material.net_rate="{ item }">
          {{
            item.gross_weight
              ? parseFloat(item.net_weight / item.gross_weight).toFixed(2) * 100
              : 0
          }}
          {{ $t("Global.rate") }}
        </template>
        <template v-slot:item.major_ingredient_flg="{ item }">
          <v-chip
            small
            label
            :color="item.major_ingredient_flg == 1 ? 'primary' : 'grey'"
            text-color="white"
          >
            {{
              item.major_ingredient_flg == 1
                ? $t("Recipes.Fields.main_ingredient")
                : $t("Recipes.Fields.ingredients")
            }}
          </v-chip>
        </template>
        <template v-slot:item.cost_flg="{ item }">
          <v-chip
            small
            label
            :color="item.cost_flg ? 'primary' : 'grey'"
            text-color="white"
          >
            {{
              item.cost_flg
                ? $t("Recipes.Fields.count_const_on")
                : $t("Recipes.Fields.count_const_off")
            }}
          </v-chip>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          class="elevation-1"
          @click="dialog = false"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
      
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Dishes from "@/api/dishes";

export default {
  name: "CostCardInfoDialog",

  props: ["value", "formulaId"],

  computed: {
    headers() {
      return [
        {
          text: i18n.t("Recipes.Fields.material_name"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "material.Description",
        },
        {
          text: i18n.t("Recipes.Fields.standard_name"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "material.standard_name",
        },
        {
          text: i18n.t("Recipes.Fields.default_unit"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "material.standard.default_standard_detail.unit",
        },
        {
          text: i18n.t("Recipes.Fields.cost_unit"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "material.cost_unit",
        },
        {
          text: i18n.t("Recipes.Fields.conversion_rate"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "material.cost_unit_rate",
        },
        {
          text: i18n.t("Recipes.Fields.net_weight"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "net_weight",
        },
        {
          text: i18n.t("Recipes.Fields.gross_weight"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "gross_weight",
        },
        {
          text: i18n.t("Recipes.Fields.net_rate"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "material.net_rate",
        },
        {
          text: i18n.t("Recipes.Fields.ingredient_type"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "major_ingredient_flg",
        },
        // TODO：暂时隐掉，具体逻辑还没出
        // {
        //   text: i18n.t("Recipes.Fields.count_const"),
        //   align: "start",
        //   sortable: false,
        //   filterable: true,
        //   value: "cost_flg",
        // },
        // {
        //   text: i18n.t("Recipes.Fields.substitute_goods"),
        //   align: "start",
        //   sortable: false,
        //   filterable: true,
        //   value: "replace_material.Description",
        // },
      ];
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },

    costCardInfoItems() {
      return this.costCardInfo
          // .map((detail) => {
          //   detail.material.Description = i18n.t(
          //       this.settings
          //           ? this.settings.material_name_display_type == 3
          //               ? "Material.materialNameWithCodeAndStandard"
          //               : this.settings.material_name_display_type == 2
          //                   ? "Material.materialNameWithCode"
          //                   : "Material.materialName"
          //           : "Material.materialName",
          //       [
          //         detail.material.material_code,
          //         detail.material.material_name,
          //         detail.material.standard_name,
          //       ]
          //   );
          //   // TODO：暂时隐掉，具体逻辑还没出
          //   if (detail.replace_material) {
          //     detail.replace_material.Description = i18n.t(
          //         this.settings
          //             ? this.settings.material_name_display_type == 3
          //                 ? "Material.materialNameWithCodeAndStandard"
          //                 : this.settings.material_name_display_type == 2
          //                     ? "Material.materialNameWithCode"
          //                     : "Material.materialName"
          //             : "Material.materialName",
          //         [
          //           detail.replace_material.material_code,
          //           detail.replace_material.material_name,
          //           detail.replace_material.standard_name,
          //         ]
          //     );
          //   }
          //   return detail;
          // });
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    foodFormula: {},
    costCardInfo: [],
    viewDetailUnit: false,
    currentDetailUnit: null,
    itemsPerPageOptions: 10,
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value && this.formulaId) {
          this.dialog = this.value;
          Dishes.fetchCostCardInfo(this.formulaId).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.foodFormula = response.data.food_formula;
                this.costCardInfo =
                  response.data.food_formula.formula_cost_card;
              }
            }.bind(this)
          );
        }
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.foodFormula = {};
          this.costCardInfo = [];
        }
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>